module.exports = __webpack_public_path__ + "/login_ui/img/gn-afea6ceac4a03e42131c6319ca8f9e55.svg";